var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 49.931 47.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.911,
    y1: 0.101,
    x2: 0,
    y2: 0.949,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee6e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7866f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1185",
    "data-name": "Trac\\xE9 1185",
    d: "M11.986,2A4.993,4.993,0,0,0,6.993,6.993V31.959a4.993,4.993,0,0,0,4.993,4.993H24.469v7.49H4.5a2.5,2.5,0,1,0,0,4.993H49.435a2.5,2.5,0,1,0,0-4.993H29.462v-7.49H41.945a4.993,4.993,0,0,0,4.993-4.993V13.235a4.993,4.993,0,0,0-4.993-4.993H27.9L24.882,4.07A4.993,4.993,0,0,0,20.835,2Zm0,4.993h8.848l3.76,5.207a2.5,2.5,0,0,0,2.024,1.035H41.945V31.959H11.986Zm2.5,19.972a2.5,2.5,0,0,1,2.5-2.5h4.993a2.5,2.5,0,1,1,0,4.993H16.979A2.5,2.5,0,0,1,14.483,26.966Zm14.979-2.5a2.5,2.5,0,0,0,0,4.993h2.5a2.5,2.5,0,0,0,0-4.993Z",
    transform: "translate(-2 -2)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadHeader);
export default __webpack_public_path__ + "static/media/UploadHeader.25cc54b02acd71248a4ff69f7d6106f8.svg";
export { ForwardRef as ReactComponent };